import { logsApi } from "./logs.api";

export const {
  useGetObjectsQuery,
  useGetOperationsQuery,
  useListLogsInfiniteQuery,
  useGetLogFiltersQuery,
  useGetLogDriverQuery,
  useLazyGetLogDriverQuery,
  useListLogDriverInfiniteQuery
} = logsApi;
